// TODO - remove becouse of legacy

import { Selector } from 'reselect'
import { ReduxState } from 'store/createRootReducer'

export const errorSelector: Selector<ReduxState, string | undefined> = (state) => state.adSpends.UIState.error
export default errorSelector
